// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy_history_box .buy_table[data-v-06b9ad7d]{width:100%}.buy_history_box .btn_active[data-v-06b9ad7d]{color:#3d6bff;cursor:pointer}.buy_history_box .help_p[data-v-06b9ad7d]{padding:20px 0;font-size:14px;font-weight:400;color:#666;text-align:center}.buy_history_box .btn_wait[data-v-06b9ad7d]{color:#999}", ""]);
// Exports
module.exports = exports;
